import axios from "axios";
import {errorHandler} from "@/services/errorHandler";

export default {
    name: "auth",
    state: {
        currentUser: {},
        allUsers: [],
        userInfo:{
            email: "",
            password: ""
        }
    },
    getters: {
        getCurrentUser: (state) => state.currentUser,
        getAllUsers: (state) => state.allUsers,
        getUserInfo: (state) => state.userInfo,
    },
    mutations: {
        setUserInfo: (state, data) => {
            state.userInfo = { ...data};
        },
        setCurrentUser: (state, data) => {
            state.currentUser = data;
        },
        setAllUsers: (state, data) => {
            state.allUsers = data
        },
        removeUserInfo(state) {
            Object.assign(state, {
                userInfo:{
                    email: "",
                    password: ""
                }
            });
        },
        logOutInfo(state) {
            Object.assign(state, {
                allUsers: [],
                Kazang:{},
                locations:{},
                transactionManager:{},
                currentUser: {},
            });
        }
    },
    actions: {
        async login(context, payload) {
            await context.commit('setUserInfo', payload)
            const url = `${ChickenLittle}auth/login`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload, method})
        },
        verifyOtp(context, payload) {
            const url = `${ChickenLittle}auth/verifyOtp`
            const method = `post`
            return axios.post(url, payload)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err) )
        },
        getUser(context, payload) {
            const userPromise = axios.get(`${ChickenLittle}users/getUser/${payload}`)
                .then(({ data }) => data)
                .catch(err => errorHandler.tomcatError(err));
            return userPromise
                .then(userData => {
                    userData.companyID = userData.companyID || this.companyID;
                    const companyID = userData.companyID;  // Now that user data is available, get companyID
                    const companyLogoPromise = axios.get(`${ChickenLittle}users/getCompanyLogo/${companyID}`)
                        .then(({ data }) => data)  // Assuming data contains the base64 string of the logo
                        .catch(err => errorHandler.tomcatError(err));
                    return companyLogoPromise
                        .then(companyLogoData => ({
                            user: userData,
                            companyLogo: companyLogoData
                        }));
                })
                .catch(err => {
                    console.error('Error fetching user or company logo:', err);
                    throw err;
                });
        },
        getUserDetailsByEmail(context, email) {
            // Get ALL users without filtering by companyID (to handle cases where localStorage has stale companyID)
            return axios.get(`${ChickenLittle}users/getAll`)
                .then(({ data }) => {
                    // Find user with matching email
                    const user = data.find(u => u.email && u.email.toLowerCase() === email.toLowerCase());
                    if (user) {
                        return user;
                    }
                    throw new Error("User not found");
                })
                .catch(err => {
                    console.error('Error fetching user by email:', err);
                    throw err;
                });
        },
        getAllUsers(context) {
            let userInfo = JSON.parse(localStorage.getItem("current_user"));
            console.log("getAllUsers - ALL userInfo keys:", Object.keys(userInfo || {}));
            console.log("getAllUsers - full userInfo:", userInfo);
            const userCompanyID = userInfo.usercompanyID || userInfo.companyID || userInfo.companyApiKey;
            console.log("getAllUsers - companyID being sent:", userCompanyID);
            if (!userCompanyID) {
                console.error("Company ID is missing from user data");
                return Promise.resolve([]);
            }
            return axios.get(`${ChickenLittle}users/getAllUsersByCompanyID`, {
                params: {
                    "companyID": userCompanyID
                }
            })
                .then(({ data }) => {
                    context.commit('setAllUsers', data);
                    return data;
                })
                .catch(error => {
                    console.error("Error:", error);
                });
        },
        editUser(context, payload) {
            const userId = payload.id;
            // Create a new object for the request body, excluding the id if it's only needed as a query param
            // Or, if your backend CreateUserRequest DTO can handle an 'id' field (and ignores it or uses it appropriately),
            // you might not need to delete it from the payload.
            // For clarity, let's assume the backend's @RequestBody CreateUserRequest does not expect the 'id' field itself.
            const requestBody = { ...payload };
            delete requestBody.id; // Remove id from the body if it's only a query parameter

            // Construct the URL with the id as a query parameter
            const url = `${ChickenLittle}users/update?id=${userId}`;
            const method = `put`;

            // Send the requestBody as the payload for the PUT request
            return context.dispatch('sendRequest', { url, payload: requestBody, method });
        },
        createUser(context, payload) {
            const url = `${ChickenLittle}users/create`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload,method})
        },
        archiveUser(context, userId) { // Renamed payload to userId for clarity
            // Construct the URL with the id as a query parameter
            const url = `${ChickenLittle}users/archive?id=${userId}`;
            const method = 'delete'; // Method is implicitly DELETE via axios.delete

            // axios.delete typically sends the URL and an optional config object.
            // If your 'sendRequest' action is a wrapper around axios,
            // you might need to adapt this or call axios.delete directly.

            // Option 1: Calling axios.delete directly (if 'sendRequest' is not suitable for DELETE with query params only)
            return axios.delete(url)
                .catch(err => {
                    // It's good practice to also handle the error within the action if possible,
                    // or ensure tomcatError re-throws or returns a rejected Promise
                    // so the component's .catch() can also react.
                    errorHandler.tomcatError(err);
                    return Promise.reject(err); // Ensure the promise chain is broken on error
                });

            // Option 2: If your 'sendRequest' action can handle DELETE with query params and no body:
            // return context.dispatch('sendRequest', { url, method /*, payload: undefined if sendRequest expects it */ })
            //   .catch(err => errorHandler.tomcatError(err)); // Assuming sendRequest also returns a promise
        },
        userResetPassword(context, payload) {
            return axios.put(`${ChickenLittle}auth/resetPassword?email=${payload}&localid=${generateUUID()}`)
            .catch(err => errorHandler.tomcatError(err) )
        },
        confirmReset: async (context, payload) => {
            payload.localID = generateUUID();
            return await axios.put(`${ChickenLittle}auth/confirmReset`, payload)
                .catch(err => errorHandler.tomcatError(err) )
        },
    }
}